import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SegmentedOption } from './anc-segmented.model';

/**
 * Pill-style segmented control: a small group of mutually-exclusive options
 * rendered inside a rounded track, with the active option lifted onto a white
 * chip. Used where a card needs to swap between a few sibling views (e.g. the
 * shipment panel's Delivery / Exporter / Importer parties). Options may carry a
 * leading status dot. Bound to design-system tokens; no hardcoded colours.
 */
@Component({
    selector: 'lib-anc-segmented',
    imports: [CommonModule, TranslateModule],
    templateUrl: './anc-segmented.component.html',
    styleUrls: ['./anc-segmented.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AncSegmentedComponent {
    /** Options to render, left to right. */
    options = input<SegmentedOption[]>([]);
    /** Value of the currently-selected option. */
    activeValue = input<string>('');
    /** Emits the selected option when the user picks a different segment. */
    selectionChange = output<SegmentedOption>();

    visibleOptions = computed(() => this.options().filter((o) => !o.hidden));

    onSelect(option: SegmentedOption): void {
        if (option.value === this.activeValue()) return;
        this.selectionChange.emit(option);
    }
}
